/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { formatDigitadoEm } from '../utils/integracaoStatus';

const MinhaDigitacaoCell = ({ row, userId }) => {
  const md = row?.minhaDigitacao;
  if (md?.temEvento === false || (!md && !row?.resumoDigitacao)) {
    return '—';
  }

  const isMine =
    md?.temEvento
    || row?.resumoDigitacao?.ultimoDigitadorId === userId
    || row?.resumoDigitacao?.digitadorId === userId;

  if (!isMine) return '—';

  const quando = md?.ultimoEventoEm || row?.resumoDigitacao?.digitadoEm;
  const dataLabel = formatDigitadoEm(quando, 'DD/MM/YY');

  return (
    <>
      <Typography variant="caption" fontWeight={700} component="span">
        Você
      </Typography>
      {dataLabel ? (
        <Typography variant="caption" component="span">
          {' '}
          ·
          {dataLabel}
        </Typography>
      ) : null}
    </>
  );
};

MinhaDigitacaoCell.propTypes = {
  row: PropTypes.object,
  userId: PropTypes.string,
};

MinhaDigitacaoCell.defaultProps = {
  row: null,
  userId: null,
};

export default MinhaDigitacaoCell;
